// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-content {
  --background: white;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.mini-week {
  display: flex;
  justify-content: center;
  padding: 5px;
  gap: 2px;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
}

.day-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 50px;
}
.day-item:hover {
  background-color: #e9ecef;
}
.day-item.selected {
  background-color: #ed143d;
  color: white;
}

.day-name {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 2px;
}

.day-number {
  font-size: 16px;
  font-weight: 600;
}

.event-area {
  flex: 1;
  position: relative;
  overflow-y: visible;
  background-color: white;
  height: 900px;
  margin: 15px;
}

.time-slot-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 60px;
  display: flex;
  align-items: flex-start;
  z-index: 1;
}
.time-slot-line.half-hour-line {
  height: 30px;
}

.time-label {
  font-size: 10px;
  color: #666;
  font-weight: 500;
  text-align: center;
  background-color: #f8f9fa;
  padding: 4px;
  border-radius: 4px;
  margin-right: 5px;
  flex-shrink: 0;
  transform: translateY(-10px);
}

.time-label-spacer {
  width: 40px;
  flex-shrink: 0;
  margin-right: 5px;
}

.dotted-line {
  flex: 1;
  height: 0;
  border-top: 2px dotted #ccc;
}
.dotted-line.half-hour-dotted {
  border-top: none;
  height: 1px;
  background-image: repeating-linear-gradient(to right, #ccc 0, #ccc 2px, transparent 2px, transparent 10px);
  background-repeat: repeat-x;
}

.current-time-line {
  position: absolute;
  left: 35px;
  height: 2px;
  right: 0;
  background-color: #ed143d;
  z-index: 10;
}
.current-time-line::before {
  content: "";
  position: absolute;
  left: 0;
  top: -3px;
  width: 8px;
  height: 8px;
  background-color: #ed143d;
  border-radius: 50%;
}

.current-time-handle {
  position: absolute;
  left: -42px;
  top: -10px;
  background-color: #ed143d;
  color: white;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  z-index: 11;
}

.event-block {
  position: absolute;
  background-color: rgba(76, 175, 80, 0.2);
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #4CAF50;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.event-block:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.event-block[style*="z-index: 5"] {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.event-block[style*="z-index: 10"] {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
}

.event-content {
  color: #333;
  font-size: 12px;
  line-height: 1.3;
}

.event-title {
  font-weight: 600;
  margin-bottom: 2px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-time {
  font-size: 10px;
  white-space: nowrap;
  margin-bottom: 2px;
}

.event-location {
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-events {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-style: italic;
  text-align: center;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/daily-calendar-modal/daily-calendar-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,gCAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,yBAAA;EACA,YAAA;AAAJ;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,OAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;AADF;AAGE;EACE,YAAA;AADJ;;AAKA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;AAFF;;AAKA;EACE,WAAA;EACA,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,OAAA;EACA,SAAA;EACA,2BAAA;AAFF;AAIE;EACE,gBAAA;EACA,WAAA;EACA,0GAAA;EAOA,2BAAA;AARJ;;AAYA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;AATF;AAWE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AATJ;;AAaA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAVF;;AAaA;EACE,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,gDAAA;EACA,iDAAA;AAVF;AAYE;EACE,2BAAA;EACA,yCAAA;AAVJ;AAcE;EACE,wCAAA;AAZJ;AAgBE;EACE,yCAAA;EACA,kBAAA;AAdJ;;AAkBA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAfF;;AAmBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAhBF","sourcesContent":[".calendar-content {\n  --background: white;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.mini-week {\n  display: flex;\n  justify-content: center;\n  padding: 5px;\n  gap: 2px;\n  align-items: center;\n  border-bottom: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n}\n\n.day-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 50px;\n\n  &:hover {\n    background-color: #e9ecef;\n  }\n\n  &.selected {\n    background-color: #ed143d;\n    color: white;\n  }\n}\n\n.day-name {\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.day-number {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.event-area {\n  flex: 1;\n  position: relative;\n  overflow-y: visible;\n  background-color: white;\n  height: calc(60px * 15); // 15 time slots * 60px each (8 AM to 11 PM)\n  margin: 15px;\n}\n\n.time-slot-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 60px;\n  display: flex;\n  align-items: flex-start;\n  z-index: 1;\n\n  &.half-hour-line {\n    height: 30px;\n  }\n}\n\n.time-label {\n  font-size: 10px;\n  color: #666;\n  font-weight: 500;\n  text-align: center;\n  background-color: #f8f9fa;\n  padding: 4px;\n  border-radius: 4px;\n  margin-right: 5px;\n  flex-shrink: 0;\n  transform: translateY(-10px);\n}\n\n.time-label-spacer {\n  width: 40px; // Match approximate width of time label + margin\n  flex-shrink: 0;\n  margin-right: 5px;\n}\n\n.dotted-line {\n  flex: 1;\n  height: 0;\n  border-top: 2px dotted #ccc;\n  \n  &.half-hour-dotted {\n    border-top: none;\n    height: 1px;\n    background-image: repeating-linear-gradient(\n      to right,\n      #ccc 0,\n      #ccc 2px,\n      transparent 2px,\n      transparent 10px\n    );\n    background-repeat: repeat-x;\n  }\n}\n\n.current-time-line {\n  position: absolute;\n  left: 35px; // Start after time label + margin\n  height: 2px;\n  right: 0;\n  background-color: #ed143d;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: -3px;\n    width: 8px;\n    height: 8px;\n    background-color: #ed143d;\n    border-radius: 50%;\n  }\n}\n\n.current-time-handle {\n  position: absolute;\n  left: -42px; \n  top: -10px;\n  background-color: #ed143d;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  z-index: 11;\n}\n\n.event-block {\n  position: absolute;\n  background-color: rgba(76, 175, 80, 0.2); // Default semi-transparent background\n  border-radius: 4px;\n  padding: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  z-index: 5; // Default z-index, will be overridden by inline style\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-left: 4px solid #4CAF50; // Default vivid left border\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  }\n\n  // Layer 1: Long events (5+ hours) - Background layer\n  &[style*=\"z-index: 5\"] {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  // Layer 2: Short events (<5 hours) - Foreground layer\n  &[style*=\"z-index: 10\"] {\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15); // More prominent shadow for foreground events\n    border-radius: 6px; // Slightly more rounded corners for foreground events\n  }\n}\n\n.event-content {\n  color: #333;\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.event-title {\n  font-weight: 600;\n  margin-bottom: 2px;\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.event-time {\n  font-size: 10px;\n  white-space: nowrap;\n  margin-bottom: 2px;\n}\n\n.event-location {\n  font-size: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n.no-events {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #666;\n  font-style: italic;\n  text-align: center;\n  font-size: 14px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
